export default "__VITE_ASSET__CUzF37I5__"